import { MAX_WIDTH_SALE_STAGE_BAR } from "@config/config";
import { SaleStageStatus } from "../SaleStageStatus.enum";
import { checkSaleStageStatus } from "./checkSaleStageStatus";

export const calcWidthSaleStageBar = (currentRound: number, maxRound: number) => {
  if (checkSaleStageStatus(currentRound, maxRound) === SaleStageStatus.Active) {
    return (MAX_WIDTH_SALE_STAGE_BAR / maxRound) * currentRound;
  } else return MAX_WIDTH_SALE_STAGE_BAR;
};
